import { Pipe, PipeTransform } from '@angular/core';
import { ApiService } from './api.service';

@Pipe({
  name: 'apiUrl',
})
export class ApiUrlPipe implements PipeTransform {
  constructor(private _apiService: ApiService) {}

  transform(url: string): string {
    return this._apiService.getUrl(url);
  }
}

@Pipe({
  name: 'apiUrlU',
  pure: false,
})
export class ApiUrlUnpurePipe extends ApiUrlPipe implements PipeTransform {}
